import { createI18n } from 'vue-i18n'
import store from './store'

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    if (key.includes('/generated/')) {
      return
    }
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const defaultLocale = store.state.lang || 'en'

export default createI18n({
  legacy: false,
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  globalInjection: true
})
